var render, staticRenderFns
import script from "./DraggableItem.vue?vue&type=script&lang=js&"
export * from "./DraggableItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableItem.vue?vue&type=style&index=0&id=1346ad80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1346ad80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\el-dynamic-form-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1346ad80')) {
      api.createRecord('1346ad80', component.options)
    } else {
      api.reload('1346ad80', component.options)
    }
    
  }
}
component.options.__file = "src/render/DraggableItem.vue"
export default component.exports